<template>
    <div>
        <PullContainer ref="pullContainerRef"  :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                        <div class="mobile_head_operate">
                            <p @click="handleClickProjectAdd"><i class="el-icon-plus"></i> 新建项目</p>
                        </div>
                    </div>
                    <div class="mobile_search">
                        <van-search
                                v-model="searchForm.keyword"
                                placeholder="请输入查询内容"
                                @clear="handleClickSearch"
                                @search="handleClickSearch">
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="searchPopupShow = true"></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="project_management_container mobile_container">
                        <ul  v-infinite-scroll="onLoadList">
                            <li v-for="(item,index) in tableData" :key="index" @click="handleClickItemDetail(item)">
                                <div class="top">
                                    <div class="title_wrap">
                                        <h5 class="ellipsis" v-text="item.project_manage_name"></h5>
                                        <span class="status_wrap">
                                            <span class="status_text status0" v-if="item.status == 0 ">进行中</span>
                                            <span class="status_text status1" v-if="item.status == 1 ">已完结</span>
                                            <span class="status_text status2" v-if="item.status == 2" >已关闭</span>
                                        </span>
                                        <span class="handle" @click.stop="handleClickItem(item)">
                                            <i class="iconfont icon-gengduo"></i>
                                        </span>
                                    </div>
                                    <div class="user_time_wrap">
                                         <span class="mobile_head_user" v-if="item.head_user" @click="handleClickUserDetail(item.head_user.uid)">
                                             <img :src="item.head_user.avatar ? item.head_user.avatar : defaultImg" alt="">
                                             <span class="ellipsis" v-text="item.head_user.name"></span>
                                        </span>
                                        <span class="line"></span>
                                        <span class="time" v-text="item.created_at"></span>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <div class="field_progress field_progress_total_price ellipsis">
                                        项目订单总金额：¥{{item.total_price}}
                                    </div>
                                    <div class="field_progress field_progress_repay_price ellipsis">
                                        <span :style="{'width': item.repay_price_ratio + '%'}"></span>
                                        实际回款总金额：¥{{item.repay_price}}
                                    </div>
                                    <div class="field_progress field_progress_total_cost ellipsis">
                                        <span :style="{'width': item.cost_price_ratio + '%'}"></span>
                                        项目成本：¥{{item.total_cost}}
                                    </div>

                                </div>
                            </li>
                        </ul>
                    </div>

                    <!--筛选-->
                    <van-popup v-if="searchPopupShow"  v-model="searchPopupShow" :close-on-click-overlay="false"
                               :style="{ height: '60%',background:'#F7F8FA' }"  position="bottom"  @click-overlay="handleClickPopupClose"  round>
                        <div class="search_popup_header">
                            <div class="arrow_left_icon" >
                                <van-icon   name="arrow-left" @click="handleClickReturn"/>
                            </div>
                            <div class="title" v-text="searchPopupTitle"></div>
                            <div class="right_btn_wrap">
                                <span v-if="conditionShowType == ''"  class="clear_btn" @click="handleClickSearchClear">清空</span>
                                <span v-else class="confirm_btn" @click="handleClickSearch"></span>
                            </div>
                        </div>
                        <div class="search_popup_content">

                            <template v-if="conditionShowType == ''">
                                <div class="condition_field_list">
                                    <div class="condition_field_item" v-for="item in searchFilterList">
                                        <div v-if="item.field_key == 'date'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择创建日期"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'status'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择项目状态"  readonly></van-field>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <ul class="condition_field_value_list" v-if="conditionShowType == 'status'">
                                    <li v-for="list in statusList" v-text="list.name" @click="handleClickSelectFilterValue(list)"></li>
                                </ul>
                            </template>
                        </div>
                    </van-popup>

                    <van-popup v-model="calendarShow" :close-on-click-overlay="true"  :style="{ height: '70vh',background:'#F7F8FA' }"  position="bottom"  round  @click-overlay="handleClickPopupRangeCalendarClose">
                        <van-calendar  :allow-same-day="true" :max-date="dateCalendarMax" :min-date="dateCalendarMin" :default-date="defaultDate"	 :poppable="false"
                                       :show-confirm="true" :show-title="false"  color="#1990FF" type="range" @confirm="handleClickRangeCalendarConfirm"></van-calendar>

                    </van-popup>

                    <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="userDetailId" />

                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" z-index="1000" v-if="handleRadioPicker" :show="handleRadioPicker" @click="handleRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li class="radio_option_item"  @click="handleClickEditProject()">编辑</li>
                                <li class="radio_option_item"  @click="handleClickChangePerson()">更换负责人</li>
                                <li class="radio_option_item" v-if="activeItem.status == 0" @click="handleClickEnd()">完结</li>
                                <li class="radio_option_item" v-if="activeItem.status == 1" @click="handleClickCancelEnd()">取消完结</li>
                                <li class="radio_option_item" v-if="activeItem.status == 0" @click="handleClickClose()">关闭</li>
                                <li class="radio_option_item" v-if="activeItem.status == 2" @click="handleClickCancelClose()">取消关闭</li>
                                <li class="radio_option_item" v-if="activeItem.status == 2" @click="handleClickDelete()">删除</li>
                            </ul>
                            <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>
                    <ChangeMembersPerson  v-if="changePersonPopupShow" :changePersonPopupShow.sync="changePersonPopupShow"  :projectId="activeItem.id" @success="handleClickSearch"/>


                </div>
            </template>
        </PullContainer>
    </div>

</template>
<script>
import { Dialog } from "vant";
import {ProjectManageList,ProjectManageDel,ProjectManageFinish, ProjectManageFinishCancel, ProjectManageClose,  ProjectManageCloseCancel} from '@/api'
import PullContainer from '@/components/mComponents/PullContainer.vue'
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import ChangeMembersPerson from "./component/change_the_person"
import {mapState} from "vuex";
import {pagination} from '@/mixins'
import {formatDate} from "@/utils";
export default {
    name: 'ProjectManagement',
    components: {
        PullContainer,
        ReturnNavBar,
        userDetailDialog,
        ChangeMembersPerson
    },
    mixins: [pagination],
    data () {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            searchForm:{
                keyword:''
            },
            userDetailPopupShow:false,
            userDetailId: 0,
            tableData:[],
            handleRadioPicker:false,
            activeItem:null,
            conditionShowType:'',
            searchPopupShow:false,
            searchPopupTitle:'',
            searchFilterList:[
                {
                    field_key: 'date',
                    field_name: '日期',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'status',
                    field_name: '状态',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
            ],
            statusList:[
                {value:'0',name:'进行中'},
                {value:'1',name:'已完结'},
                {value:'2',name:'已关闭'},
            ],
            calendarShow:false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            defaultDate:[],
            changePersonPopupShow:false,
        }
    },
    computed: {

    },
    mounted () {
        this.getTableData()
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true
                this.handleClickSearch()
            }
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.tableData =  []
            this.getTableData()
        },
        handleClickSelectFilter(item){
            this.conditionShowType = item.field_key
            if(item.field_key == 'status'){

            }else if(item.field_key == 'date'){
                this.calendarShow = true
            }

        },
        // 选择日期
        handleClickRangeCalendarConfirm(range){
            const [start, end] = range
            let value = [formatDate(start, 'date'), formatDate(end, 'date')]
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value = value
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value_name = value.join(' - ')
            this.calendarShow = false
            this.conditionShowType = ''
        },
        // 取消选择日期
        handleClickPopupRangeCalendarClose(){
            this.conditionShowType = ''
        },
        // 选择状态
        handleClickSelectFilterValue(list){
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value = list.value
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value_name = list.name
            this.calendarShow = false
            this.conditionShowType = ''
        },
        // 关闭筛选弹出
        handleClickPopupClose(){
            this.searchPopupShow = false
            this.handleClickSearch()
        },
        // 筛选返回上一步
        handleClickReturn(){
            if(this.conditionShowType){
                this.conditionShowType = ''
            }else{
                this.searchPopupShow = false
                this.handleClickSearch()
            }
        },
        // 筛选清空
        handleClickSearchClear(){
            this.searchFilterList.forEach((item)=>{
                item.field_value = ''
                item.field_value_name = ''
            })
        },


        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize:this.pagination.pageSize,
                keyword:this.searchForm.keyword
            }
            this.searchFilterList.forEach((item)=>{
                postData[item.field_key] = item.field_value
            })
            ProjectManageList(postData).then(res => {
                if (res.code === 200) {
                    let {data,total} = res.data
                    data.forEach(item => {
                        this.$set(item, 'order',  item.relates.filter(item=>item.relate_type==='order').length ? item.relates.filter(item=>item.relate_type==='order') : [])
                        this.$set(item,'total_price',item.order.reduce((acc, order) => acc + Number(order.relate_detail.total_price), 0).toFixed(2))
                        this.$set(item,'no_repay_price',item.order.reduce((acc, order) => acc + Number(order.relate_detail.no_repay_price), 0).toFixed(2))
                        this.$set(item,'repay_price',item.order.reduce((acc, order) => acc + Number(order.relate_detail.repay_price), 0).toFixed(2))
                        this.$set(item,'repay_price_ratio',isNaN(Number(item.repay_price) / Number(item.total_price) ) ? 100 : Number((Number(item.repay_price) / Number(item.total_price)  * 100).toFixed(2))) //回款比例
                        this.$set(item,'cost_price_ratio',isNaN(Number(item.total_cost) / Number(item.total_price) ) ? 100 : Number((Number(item.total_cost) / Number(item.total_price)  * 100).toFixed(2))) //成本比例
                    })
                    this.tableData = this.tableData.concat(data)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                    this.loading = false
                    if(this.pullDownLoading){
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                    }
                }

            })
        },
        // 新建
        handleClickProjectAdd(){
            this.$router.push({
                name:'ProjectAdd',
                params:{
                    isPush:true
                }
            })

        },
        // 选择三个点
        handleClickItem(item){
            this.activeItem = item
            this.handleRadioPicker = true
        },
        // 详情
        handleClickItemDetail(item){
            this.$router.push({
                name:'ProjectDetail',
                query:{
                    id:item.id,
                    name:item.project_manage_name
                },
                params:{
                    isPush:true
                }
            })
        },
        // 编辑
        handleClickEditProject(){
            this.$router.push({
                name:'ProjectEdit',
                query:{
                    id:this.activeItem.id
                },
                params:{
                    isPush:true
                }
            })
        },
        // 更换负责人
        handleClickChangePerson(){
            this.changePersonPopupShow = true
        },
        // 完结
        handleClickEnd(){
            Dialog.confirm({
                title: "完结提示",
                message: "项目完结后，将不再同步数据，在选择项目时，该项目将隐藏，无法关联",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectManageFinish({id:this.activeItem.id}).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '完结成功',
                            type: "success",
                            duration: 1000,
                            onClose: () => {

                            },
                        });
                        this.handleClickSearch()
                    }
                })
            })
            .catch(() => { });
        },
        // 取消完结
        handleClickCancelEnd(){
            Dialog.confirm({
                title: "取消完结",
                message: "确定要取消完结吗？已关联的数据将同步更新",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectManageFinishCancel({id:this.activeItem.id}).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '取消完结成功',
                            type: "success",
                            duration: 1000,
                            onClose: () => {

                            },
                        });
                        this.handleClickSearch()
                    }
                })
            })
            .catch(() => { });
        },
        // 关闭
        handleClickClose(){
            Dialog.confirm({
                title: "关闭提示",
                message: "关闭项目后未处理完的事项将不再同步，在选择项目时，该项目将隐藏，无法关联",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectManageClose({id:this.activeItem.id}).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '关闭成功',
                            type: "success",
                            duration: 1000,
                            onClose: () => {

                            },
                        });
                        this.handleClickSearch()
                    }
                })
            })
            .catch(() => { });
        },
        // 取消关闭
        handleClickCancelClose(){
            Dialog.confirm({
                title: "取消关闭",
                message: "确定要取消关闭吗？已关联的数据将同步更新",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectManageCloseCancel({id:this.activeItem.id}).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '取消关闭成功',
                            type: "success",
                            duration: 1000,
                            onClose: () => {

                            },
                        });
                        this.handleClickSearch()
                    }
                })
            })
            .catch(() => { });
        },
        // 删除
        handleClickDelete(){
            Dialog.confirm({
                title: "删除提示",
                message: "确定要删除该项目吗？删除后，项目数据将会清空",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectManageDel({id:this.activeItem.id}).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '删除成功',
                            type: "success",
                            duration: 1000,
                            onClose: () => {

                            },
                        });
                        this.handleClickSearch()
                    }
                })
            })
            .catch(() => { });
        },
    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>
